'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_Fetcher$UnifiedErrorFormat(origin, message, status, code, trace) {
  this.Jx = null;
  this.wQ = null;
  this.Jy = 0;
  this.Jw = null;
  this.Jz = null;
  this.Jx = origin;
  this.wQ = message;
  this.Jy = status;
  this.Jw = code;
  this.Jz = trace;
}
export { $c_Lpresto_Fetcher$UnifiedErrorFormat as $c_Lpresto_Fetcher$UnifiedErrorFormat };
$p = $c_Lpresto_Fetcher$UnifiedErrorFormat.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Fetcher$UnifiedErrorFormat;
/** @constructor */
function $h_Lpresto_Fetcher$UnifiedErrorFormat() {
}
export { $h_Lpresto_Fetcher$UnifiedErrorFormat as $h_Lpresto_Fetcher$UnifiedErrorFormat };
$h_Lpresto_Fetcher$UnifiedErrorFormat.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("UnifiedErrorFormat"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.Jx));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.wQ));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.Jy);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.Jw));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.Jz));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().al(acc, 5);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_Fetcher$UnifiedErrorFormat)) {
    if ((((this.Jy === x$0.Jy) && (this.Jx === x$0.Jx)) && (this.wQ === x$0.wQ))) {
      var x = this.Jw;
      var x$2 = x$0.Jw;
      var $x_1 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Jz;
      var x$4 = x$0.Jz;
      return ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 5;
});
$p.s = (function() {
  return "UnifiedErrorFormat";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.Jx;
      break;
    }
    case 1: {
      return this.wQ;
      break;
    }
    case 2: {
      return this.Jy;
      break;
    }
    case 3: {
      return this.Jw;
      break;
    }
    case 4: {
      return this.Jz;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_Fetcher$UnifiedErrorFormat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.im)));
}
export { $isArrayOf_Lpresto_Fetcher$UnifiedErrorFormat as $isArrayOf_Lpresto_Fetcher$UnifiedErrorFormat };
var $d_Lpresto_Fetcher$UnifiedErrorFormat = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Fetcher$UnifiedErrorFormat, "presto.Fetcher$UnifiedErrorFormat", ({
  im: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_Fetcher$UnifiedErrorFormat as $d_Lpresto_Fetcher$UnifiedErrorFormat };
//# sourceMappingURL=presto.-Fetcher$-Unified-Error-Format.js.map
